module.exports = __webpack_public_path__ + "img/ap32-register-title-text.8a99e1e0.png";